var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"student__headerGoal-list"},_vm._l((_vm.linkList),function(ref){
var text = ref.text;
var link = ref.link;
var id = ref.id;
return _c('a',{staticClass:"student__headerGoal-link",class:{ active: _vm.currentPath == link || (_vm.currentPath == "/student/v3/dashboard" && id == _vm.idGoalList) },attrs:{"href":link}},[_vm._v(_vm._s(text))])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }